// extracted by mini-css-extract-plugin
export default {"loader":"loader-secondary_loader__l3rIE","d3":"loader-secondary_d3__HTfhu"};